import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const fmtQty = (n) => (n == null ? "0" : Number(n).toLocaleString("cs-CZ", { maximumFractionDigits: 3 }));

// Převod na jiný sklad (§7) — jediné místo v UI, kde se vybírá cílový sklad.
export function TransferDialog({ item, targets, busy, onSubmit, onClose }) {
  const [to_warehouse_id, setTo] = useState("");
  const [qty, setQty] = useState("");
  const [note, setNote] = useState("");
  const over = Number(qty) > (item.qty || 0);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[85vh] overflow-y-auto" data-testid="transfer-dialog">
        <DialogHeader><DialogTitle>Převod — {item.name}</DialogTitle></DialogHeader>
        <div className="space-y-3.5">
          <p className="text-sm text-muted-foreground">Na skladě {fmtQty(item.qty)} {item.unit}.</p>
          <div>
            <Label>Cílový sklad *</Label>
            <Select value={to_warehouse_id} onValueChange={setTo}>
              <SelectTrigger className="h-11 mt-1 w-full min-w-0" data-testid="transfer-target-select"><SelectValue placeholder="Vyberte sklad" /></SelectTrigger>
              <SelectContent>{targets.map((w) => <SelectItem key={w.id} value={w.id}>{w.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label>Množství * ({item.unit})</Label>
            <Input type="number" step="0.001" value={qty} onChange={(e) => setQty(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="transfer-qty" />
            {over && <p className="text-xs text-destructive mt-1">Na skladě je jen {fmtQty(item.qty)} {item.unit}.</p>}
          </div>
          <div>
            <Label>Poznámka</Label>
            <Input value={note} onChange={(e) => setNote(e.target.value)} className="h-11 mt-1 w-full min-w-0" data-testid="transfer-note" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" className="w-full md:w-auto" onClick={onClose}>Zrušit</Button>
          <Button className="w-full md:w-auto" onClick={() => onSubmit({ to_warehouse_id, qty, note })} disabled={busy || over || !to_warehouse_id || !qty} data-testid="transfer-confirm">
            {busy ? "Ukládám…" : "Převést"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
